<template>
  <div>
    <Navigation />
    <div class="grid__section">
    <section class="section__container top__container blog__details">
       

      <h1 class="title center__text">
        ENVOI SMS ADMINISTRATIONS / COLLECTIVITÉS / SECTEUR PUBLIC
      </h1>
               <img class="card__image" src="/../images/local.png" alt="" />
      <h2>Découvrez une fonctionnalité révolutionnaire pour le secteur public.</h2>
      <p>
        Si vous êtes un professionnel de la fonction publique, notre plateforme Services-SMS vous offre la solution idéale
        pour l'envoi efficace de vos SMS en masse afin de rappeler vos rendez-vous. Grâce à notre plateforme, l'organisation 
        de votre accueil du public sera améliorée et simplifiée. Vous pourrez optimiser la gestion de votre agenda en 
        planifiant des rendez-vous avec vos administrés et réduire jusqu'à 75% le nombre de rendez-vous reportés ou manqués
        en raison d'absentéisme.
      </p>
      <p>
        La plateforme servicesms.sn vous permet d'envoyer facilement des SMS en masse à vos contacts en un simple clic.
        Vos administrés recevront une alerte SMS les rappelant de ne pas oublier leur rendez-vous dans votre service, à la date indiquée.
      </p>
      <p>
        Les avantages du rappel de rendez-vous avec servicesms.sn sont nombreux :
      </p>
      
        <li>Le SMS est le moyen de rappel le plus efficace, avec un taux d'ouverture et de rétention de 95%, en particulier s'il est envoyé la veille à une heure préprogrammée, comme en début de soirée.</li>
        <li>Les SMS seront lus dans les 5 minutes suivant leur envoi grâce à nos solutions SMS PRO.</li>
     
      <h2>Comment établir une proximité avec vos administrés ?</h2>
      <p>
        Les enquêtes révèlent de manière récurrente que pour offrir un service public de qualité, 
        il est essentiel d'établir une communication de proximité claire, simple, rapide et moderne.
        En informant activement les citoyens sur les actualités de leur ville, commune, département 
        ou région, on renforce le sentiment d'une gestion publique efficace et bénéfique pour tous.
      </p>
      <h2>
        Dans le secteur public, il existe diverses situations où l'envoi de SMS<br/> serait bénéfique et utile.
      </h2>
      
        <li>Diffusion d'informations pratiques</li>
         <li>Alertes météo</li>
        <li>Alertes sanitaires <br /></li>
        <li>Notifications de modifications de circulation ou de travaux temporaires <br /></li>
        <li>Notifications de remise de pièces administratives en attente<br /></li>
        <li>Annonces de rencontres sportives</li>
       <li> Annonces d'événements culturels, etc. <br /></li>
        
      <h2>Exemples de campagnes SMS dans le secteur public :</h2>
      <div class="cards">
        <div class="card">
          <img class="card__image" src="/../images/local-mairi-1.png" />
        </div>
        <div class="card">
          <img class="card__image" src="/../images/local-mairi-2.png" />
        </div>
        <div class="card">
          <img class="card__image" src="/../images/local-mairi-3.png" />
        </div>
      </div>
    </section>
    <SideNav/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Navigation from "./Navigation";
import Footer from "./Footer";
import SideNav from "./SideNav";
export default {
  components: {
    Navigation,
    Footer,
    SideNav
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";

.card{
    background: $color-grey;
}
</style>
